<template>
	<div class="businessAdd">
		<div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle">基本信息</div>
				<div class="panelContent">
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 用户类型</div>
            <div class="rightInput">
              <span type="info" v-if="selectType==1">个人</span>
              <span type="info" v-if="selectType==2">公司</span>
             <!-- <select name="" id="" v-model="selectType" disabled="true">
                <option value="">请先选择用户类型</option>
                <option value="1">个人</option>
                <option value="2">公司</option>
              </select> -->
            </div>
          </div>

          <div class="oneLine">
            <div class="label "><i class="red">*</i> 身份标签</div>
            <div class="rightInput "  >
              <span v-if="type==1">供应商</span>
              <span v-if="type==2">销售商</span>
           <!--   <input type="radio" name="idetify" value="1" v-model="type" disabled="true">
                供应商&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="radio" name="idetify" value="2"  v-model="type" disabled="true">销售商 -->
            </div>
          </div>
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 注册/登录手机号</div>
            <div class="rightInput bold">
              <span>{{phone}}</span>
              <!-- <input type="text" class="input" placeholder="请输入"  v-model="phone" disabled="true"> -->
            </div>
          </div>
          <div class="oneLine" v-if="selectType==1">
            <div class="label "><i class="red">*</i> 个人姓名</div>
            <div class="rightInput bold">
              <input type="text" class="input" placeholder="请输入" v-model="name">
            </div>
          </div>
          <div class="oneLine" v-if="selectType==2">
            <div class="label"><i class="red">*</i> 公司名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="companyName">
            </div>
          </div>


          <div class="oneLine">
            <div class="label">联系人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="contactName">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="contactPhone">
            </div>
          </div>
          <div class="oneLine" v-show="selectType==2">
            <div class="label">公司地址</div>
            <div class="rightInput">
              <addressSelect :proviceId="proviceId" :cityId="cityId" :distId="distId"  @changeSelect="changeAddress"></addressSelect>
              <br>
              <br>
              <input type="text" v-model="addressDetail" placeholder="请输入详细地址" style="padding:7px;vertical-align: top; width: 310px;">
            </div>
          </div>
          <!-- button -->
          <div class="btnBox">
            <el-button plain @click="back">返回</el-button>
            <el-button type='primary' @click="openModal">修改基本信息</el-button>
          </div>


				</div>
			</div>
      <div class="panelBlock">
      	<div class="panelTitle">现有品牌</div>
      	<div class="panelContent">
          <div class="oneline">
            <span v-if="brandArr.length==0">暂无</span>
            <el-tag type="danger" v-for="(list,index) in brandArr" style="margin: 5px;">{{list}}</el-tag>
          </div>
          <div class="btnBox">
            <el-button plain @click="back">返回</el-button>
            <el-button @click="toEditBrand" type='danger'>添加品牌</el-button>
          </div>
          <!-- <hr style="border:1px dotted #ddd">
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 用户状态</div>
            <div class="rightInput">
              <span :class="tagWord[user_state]">{{ userState[user_state] }}</span>
              <el-button class="tagBtn" size="small"  type="primary" @click="toAuth">点击审核</el-button>
            </div>
          </div> -->
        </div>
      </div>
      <div class="panelBlock">
      	<div class="panelContent">
          <div class="oneLine">
            <div class="rightInput">
              账户状态：
              <span class="bold" :class="tagWord[user_state]">{{ userState[user_state] }}</span>
            </div>
          </div>
          <div class="btnBox">
            <el-button plain @click="back">返回</el-button>
            <el-button @click="toAuth" type='success'>点击审核</el-button>
          </div>
        </div>
      </div>
      <el-dialog  title="提交信息确认"	center	  :visible.sync="isShowModal" >
          <div class="modalWrap">

            <div class="oneLine">
              <div class="label">用户类型:</div>
              <div class="rightInput">
                <span v-if="selectType==2">公司</span>
                <span v-if="selectType==1">个人</span>
              </div>
            </div>
            <div class="oneLine" v-if="selectType==1">
              <div class="label">个人姓名:</div>
              <div class="rightInput">{{name}}</div>
            </div>
            <div class="oneLine" v-if="selectType==2">
              <div class="label">公司名称</div>
              <div class="rightInput">{{companyName}}</div>
            </div>
            <div class="oneLine">
              <div class="label">注册/登录手机号:</div>
              <div class="rightInput">{{phone}}</div>
            </div>
            <div class="oneLine">
              <div class="label">身份标签:</div>
              <div class="rightInput">
                <span v-if="type==2">销售商</span>
                <span v-if="type==1">供应商</span>
              </div>
            </div>
            <div class="oneLine">
              <div class="label">联系人姓名:</div>
              <div class="rightInput">{{contactName}}</div>
            </div>
            <div class="oneLine">
              <div class="label">联系人手机:</div>
              <div class="rightInput">{{contactPhone}}</div>
            </div>
            <div class="oneLine" v-if="selectType==2">
              <div class="label">公司地址:</div>
              <div class="rightInput">{{proviceText}}{{cityText}}{{distText}}{{addressDetail}}</div>
            </div>


          </div>
          <div class="bottomBtnLine">
            <el-button  @click="closeModal" plain>取消</el-button>
            <el-button type="primary" @click="submitClick" style="margin-right: 60px;">确认修改</el-button>
          </div>

      </el-dialog>
      <addbrand :isShow="isShowAddBrandModal" :info="currentAddModalObj" @close="closeAddModal" @closeAndSuccess="closeAddModalAndSucess"></addbrand>
      <userauth v-show="isShowAuthModal" :info="currentAuthModalObj" @close="closeAuthModal" @success="closeAuthModalAndSucess"></userauth>
		</div>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import addbrand from '@/components/addBrand.vue'
  import userauth from '@/components/userauth.vue'
  import addressSelect from '@/components/addressSelect'
	export default {
		name: 'adminIndex',
		data() {
			return {
        selectType:'',
				isLoading:false,
        isShowModal:false,
        name:'',
        phone:'',
        type:'',
        contactName:'',
        contactPhone:'',
        user_state:'',
        companyName:'',
        brandArr:[],
        keyUserId:'',
        infoObj:{},

        isShowAddBrandModal:false,
        currentAddModalObj:{},
        tagWord: {
          y:'green',
          n:'grey',
          p:'red',
        },
        userState:{
          y:'通过',
          n:'被拒绝',
          p:'待审核',
        },

        isShowAuthModal:false,
        currentAuthModalObj:{},
        // ditu
        proviceText:"",
        cityText:'',
        distText:'',
        proviceId:"",
        cityId:'',
        distId:'',
        addressDetail:'',//详细地址


			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			}
		},
		components: {
		  addbrand,userauth,addressSelect
		},
		methods: {
      changeAddress(data){
        // console.log(JSON.stringify(data))
        this.proviceId=data.proviceId
        this.proviceText=data.proviceText
        this.cityId=data.cityId
        this.cityText=data.cityText
        this.distId=data.distId
        this.distText=data.distText
      },
      toAuth(list){
          this.isShowAuthModal=true
          this.currentAuthModalObj=this.infoObj
          this.currentAuthModalObj.user_cellphone=this.infoObj.phone
      },
      closeAuthModal() {
        console.log("审核关闭方法被触发")
        this.isShowAuthModal = false
      },
      closeAuthModalAndSucess() {
        console.log("审核关闭并且成功方法被触发")
        this.isShowAuthModal = false
        this.currentAuthModalObj = {}
        this.getDetail()
      },

      closeAddModal(){
        console.log("关闭方法被触发")
        this.isShowAddBrandModal=false
      },
      closeAddModalAndSucess(){
        console.log("关闭并且成功方法被触发")
        this.isShowAddBrandModal=false
        this.currentAddModalObj={}
        this.getDetail()
      },
      toEditBrand(){
          let _this=this
          this.isShowAddBrandModal=true
          let arg={
            userId: _this.$route.query.userId
          }
          let brandArr=[]
          ajaxPost('/commodity/brandListByUser', arg).then(function(res){
            console.log(res)
            if(res.errorCode==200){
              res.data.map(function(item,index){
                brandArr.push(item.item_display_name)
              })

            }else{
              brandArr=[]
            }
            _this.currentAddModalObj={
              userId: _this.$route.query.userId,
              name:_this.companyName||_this.name,
              brandArr:brandArr
            }
          })


      },
      getDetail(){
        let _this=this
        let userId=this.$route.query.userId
        let arg={
          userId:this.$route.query.userId
        }
        // 查询基本信息
        ajaxPost('/admin/getDwUserInfo', arg).then(function(res) {
          if(res.errorCode==200){

            // user_contact_cellphone: "13023621792"
            // user_id: "543"
            // user_individual_name: "5433姓名222"
            // user_last_type: ""
            // user_organization_name: "543司名"
            // user_register_time: "2020-07-13 17:27:13"
            // user_state: "y"
            let resObj=res.data[0]||{}

            _this.infoObj=res.data[0]||{}
            _this.name=resObj.user_individual_name
            _this.phone=resObj.phone
            _this.keyUserId=resObj.user_id
            _this.type=resObj.user_initial_type
            _this.contactName=resObj.user_contact_person
            _this.contactPhone=resObj.user_contact_cellphone
            _this.companyName=resObj.user_organization_name
            _this.user_state=resObj.user_state

            _this.proviceText=resObj.company_province
            _this.cityText=resObj.company_city
            _this.distText=resObj.company_district
            _this.proviceId=resObj.user_province
            _this.cityId=resObj.user_city
            _this.distId=resObj.user_district
            _this.addressDetail=resObj.user_address

            if(_this.companyName){
              _this.selectType=2
            }else{
              _this.selectType=1
            }

          }else{
          }
        }, function(res) {})
        // 查询品牌
        let brandArr=[]
        ajaxPost('/commodity/brandListByUser', arg).then(function(res){
          console.log(res)
          if(res.errorCode==200){
            res.data.map(function(item,index){
              brandArr.push(item.item_display_name)
            })

          }else{
            brandArr=[]
          }
          _this.brandArr=brandArr
        })
      },
			back(){
				this.$router.back()
			},
      submitClick(){
        let _this=this
        let arg={
          // phone:_this.phone,
          userId:_this.keyUserId,
          // userIndividualName:_this.name,
          // userOrganizationName:_this.companyName,
          // userInitialType:_this.type,
          companyKeyPerson:_this.contactName,
          companyKeyPersonPhone:_this.contactPhone,
          userDeviceInfo:navigator.userAgent,
        }
        if(this.selectType==1){//个人，公司为空
          arg.userIndividualName=this.name
          arg.userOrganizationName=""
        }else if(this.selectType==2){//公司,个人为空
          arg.userOrganizationName=this.companyName
          arg.userIndividualName=""

          arg.userProvince=this.proviceId
          arg.company_provice=this.proviceText
          arg.userCity=this.cityId
          arg.company_city=this.cityText
          arg.userDistrict=this.distId
          arg.company_district=this.distText
          arg.userAddress=this.addressDetail
        }
        console.log(arg)
        ajaxPost('/admin/updateUserInfoByUid', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "编辑成功",
               type: 'success',
            });
            _this.$router.back()
          }else{
            // _this.$message({
            //    message: res.errorMsg,
            //    type: 'error',
            // });
          }
        }, function(res) {})

      },
      openModal(){
        let _this=this
        if(!this.selectType||!this.phone||!this.type){
          _this.$message({
             message:"带*号的为必填项",
             type: 'error',
          });
        }else if(!json.phoneReg.test(this.phone)){
          _this.$message({
             message:"登录用手机号格式不正确",
             type: 'error',
          });
        }else if(this.contactPhone&&(!json.phoneReg.test(this.contactPhone))){
          _this.$message({
             message:"联系人手机号格式不正确",
             type: 'error',
          });
        }else if(this.selectType==1){
          if(!this.name){
            _this.$message({
               message:"用户姓名为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }

        }else if(this.selectType==2){
          if(!this.companyName){
            _this.$message({
               message:"公司名称为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }
        }

      },
			closeModal(){
				this.isShowModal=false
			},
		},
		mounted() {
			let _this = this
      this.getDetail()
		},
	}
</script>

<style scoped lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .businessAdd{
     padding:20px;padding-bottom:100px;
    .panelBlock{
       background: #fff;
      box-shadow: 0 0 13px #ddd; width: 45%; vertical-align: top;margin-right: 20px;margin-top:20px;
      display: inline-block;
      float:left;
      .panelTitle{font-weight: bold;padding:10px;}
      .panelContent{
        padding:10px 20px;
      }
    }
    .btnBox{
      // text-align: center;
      padding:20px;
    }
  }
  .oneLine{
    padding:10px;
    .label{display: inline-block;padding:0 20px;vertical-align: top;}
    .rightInput{display: inline-block;}
  }
  .bottomBtnLine{padding-left:30px;}

</style>



// WEBPACK FOOTER //
// src/pages/user/edit.vue